import { render, staticRenderFns } from "./HelpDetailsComponent.vue?vue&type=template&id=37dc8124&scoped=true&"
import script from "./HelpDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./HelpDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelpDetailsComponent.vue?vue&type=style&index=0&id=37dc8124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc8124",
  null
  
)

export default component.exports